/**
 * useNavItems
 */

import {
    Queries,
    ApolloLib,
} from 'bdvp-graphql';

const { useApolloClient } = ApolloLib;
const { GET_NAV_ITEMS } = Queries;

const useNavItems = () => {

    const client = useApolloClient();
    const { navItems } = client.readQuery({ query: GET_NAV_ITEMS });

    return {
        navItems,
    };

};

export default useNavItems;
